<template>
  <span class="container">
    <a
      class="container__subscribe"
      href="javascript:;"
      data-action="follow_gold"
      data-assettype="gold"
      :data-assetname="dataAssetName"
      @click="addWatchlist()"
    >
      <i
        :class="{ 
          'fas fa-spinner-third fa-spin': loadingFollowing, 
          'fas fa-star': !loadingFollowing, 
          'container__subscribe--following': isFollowing 
          }"
      ></i>
    </a>
    <Toast
      v-if="toggleToast"
      :toggleToast="toggleToast"
      :status="toastStatus"
      :toastType="toastType"
      :options="options"
      @close-toast="closeToast"
    />
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import CarryActionAfterLogin from "@/components/mixins/carry-action-after-login"

export default {
  mixins: [CarryActionAfterLogin],
  components: {
    Toast: () => import("@/components/miniapp/global/Toast.vue")
  },
  props: {
    followingType: {
      type: String,
      default: "",
      required: true
    },
    item: {
      type: Object,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      loadingFollowing: false,
      options: {
        dialog: {
          title: "เลิกติดตาม",
          body: "ต้องการเลิกติดตาม",
          action: [
            {
              action1: "ใช่",
              action2: "ไม่ใช่"
            }
          ]
        },
        toast: {
          duration: 2
        }
      },
      toggleToast: false,
      toastType: null,
      toastStatus: false,
      isFollowing: false,
    }
  },
  watch: {
    async item() {
      await this.doWatchListProcess()
    },
  },
  computed: {
    ...mapGetters("watchlist", ["getGoldWatchlist"]),
    ...mapGetters("auth", ["getIslogin"]),
    dataAssetName() {
      switch (this.item.ID) {
        case "gold-trader-bar":
          return "bar"
        case "gold-trader-ornament":
          return "ornaments"
        case "gold-spot":
          return "spot"
        default:
          return ""
      }
    },
    transformSubjectID() {
      switch (this.item.ID) {
        case 'gold-trader-ornament':
          return 'gold_ornaments'
        case 'gold-trader-bar':
          return 'gold_bar'
        case 'gold-spot':
          return 'gold_spot'
        default:
          return ""
      }
    }
  },
  async mounted() {
    await this.doWatchListProcess()
  },
  async activated() {
    if (this.getIslogin) {
      this.isFollowing = await this.checkAssetInWatchlist({
        subjectType: 'gold',
        id: this.transformSubjectID,
      })
    }
  },
  deactivated() {
    this.isFollowing = false
  },
  methods: {
    ...mapActions("watchlist", ["checkAssetInWatchlist", "updateWatchlist"]),
    async doWatchListProcess() {
      await new Promise(resolve => setTimeout(resolve, 3000))
      if (!this.getIslogin) {
        return
      }
      this.isFollowing = await this.checkAssetInWatchlist({
        subjectType: 'gold',
        id: this.transformSubjectID,
      })
      let taskProcess = await this.mixins_get_task("task-after-login")
      if (taskProcess && taskProcess.action == "watchlist") {
        if (taskProcess.criteria && taskProcess.criteria.id == this.item.ID) {
          await this.mixins_delete_task("task-after-login")
          if (!this.isFollowing) {
            await this.watchListProcess()
          }
        }
      }
    },
    async addWatchlist() {
      if (!this.getIslogin) {
        let obj = {
          action: "watchlist",
          criteria: {
            id: this.item.ID
          }
        }
        await this.mixins_set_task("task-after-login", obj)
        this.redirectToAuth()
      } else {
        await this.watchListProcess()
      }
    },
    redirectToAuth() {
      let return_url = `${this.$route.fullPath}`
      window.location.replace(`/login?return_url=${encodeURIComponent(return_url)}`)
    },
    closeToast(bool) {
      this.toggleToast = bool
    },
    async watchListProcess() {
      this.loadingFollowing = !this.loadingFollowing
      const action = this.isFollowing ? 'unfollow': 'follow'
      const data = {
        subject_id: this.transformSubjectID,
      }
      this.options.toast.title = action == 'follow' ? [{ success: "ติดตามสำเร็จ", unsuccess: "ติดตามไม่สำเร็จ" }] : [{ success: "เลิกติดตามสำเร็จ", unsuccess: "เลิกติดตามไม่สำเร็จ"}]
      const updateResult = await this.updateWatchlist({ 
        subjectType: 'gold', 
        action: action, 
        payload: data 
      })

      setTimeout(() => {
        this.loadingFollowing = !this.loadingFollowing
        if (updateResult) {
          this.isFollowing = !this.isFollowing
        }
        this.toastType = "alert"
        this.toastStatus = updateResult == true
        this.toggleToast = true
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles/_FollowingGold";
</style>